import styled, {
  keyframes,
} from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

export const CalendarScrollerContainer = styled.div`
  position: fixed;
  right: 25px;
  bottom: ${(props) => {
    if (props.position) {
      if (props.position === 'top') {
        return 'unset';
      }
      if (props.position === 'down') {
        return '0px';
      }
    }
    return null;
  }};
  width: 50px;
  height: 50px;
  background: rgba(23, 43, 77, .4);
  cursor: pointer;
  z-index: 1001;
  animation: ${props => (props.chevronFadeOut ? fadeOut : fadeIn)} .7s ease-in-out;

  &:hover,
  &:focus {
    background: rgba(23, 43, 77, .5);
  }
`;

export const ChevronImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 18px;
  transform: translate(-50%, -50%) ${(props) => {
    if (props.direction) {
      if (props.direction === 'top') {
        return 'rotate(90deg)';
      }
      if (props.direction === 'down') {
        return 'rotate(-90deg)';
      }
    }
    return null;
  }};
`;
